import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  ChartOptions,
  Tooltip,
  ChartTypeRegistry,
  registerables,
} from "chart.js";
import { Chart as ChartJs2 } from "react-chartjs-2";
import React from "react";
import { Box, makeStyles, MenuItem, Select, styled } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  ...registerables
);
const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    border: 0,
    backgroundColor: "transparent",
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  icon: {
    top: 4,
    fontSize: "26px",
  },
});

interface IChart {
  type: keyof ChartTypeRegistry;
  options: ChartOptions;
  data: any;
}
export const Line = styled(Box)(() => ({
  width: "24px",
  height: "1px",
  backgroundColor: "#1A3036",
  marginRight: 4,
}));

export const Chart = ({
  options,
  data,
  type,
  comparisonYear,
}: IChart & { comparisonYear?: string }) => {
  const classes = useStyles();
  return (
    <>
      <ChartJs2 height={182} type={type} options={options} data={data} />
      {type !== "line" && (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          pt="6px"
          pb="6px"
        >
          <Select
            IconComponent={ExpandMoreIcon}
            inputProps={{
              classes: {
                icon: classes.icon,
              },
            }}
            classes={{ root: classes.root }}
            className={classes.root}
            value={comparisonYear}
          >
            <MenuItem value={comparisonYear}>{comparisonYear}</MenuItem>
          </Select>
        </Box>
      )}
    </>
  );
};
